import React from "react";
import "./Sector_We_Serve.css";
import Sector_We_Serve_card from "./Sector_We_Serve_card/Sector_We_Serve_card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import lottie_1 from "./LOTTIE/SECTOR/Government_1.json";
import lottie_2 from "./LOTTIE/SECTOR/Banking_Fee.json";
import lottie_3 from "./LOTTIE/SECTOR/Fast_Delivery_On_Location.json";
import lottie_4 from "./LOTTIE/SECTOR/Billboard.json";
import lottie_5 from "./LOTTIE/SECTOR/Hotel_building.json";
import lottie_6 from "./LOTTIE/SECTOR/A_boy_is_pointing_at_the_graph.json";
import lottie_7 from "./LOTTIE/SECTOR/Advertising_Display.json";
import lottie_8 from "./LOTTIE/SECTOR/cement.json";
import lottie_9 from "./LOTTIE/SECTOR/media.json";
import lottie_10 from "./LOTTIE/SECTOR/Education_Reward.json";

function Sector_We_Serve() {
  return (
    <>
      <section className="Sector_We_Serve">
        <div className="container">
          <div className="heading_holder">
            <h1 className="heading">Sector We Serve</h1>
          </div>

          <div className="Sector_We_Serve_card_holder">
            <Swiper
              className="Sector_We_Serve_swiper"
              spaceBetween={10}
              slidesPerView={4.5}
              navigation={true}
              modules={[Navigation, Autoplay]}
              breakpoints={{
                // when window width is >= 320px
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },

                379: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                // when window width is >= 480px
                480: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                // when window width is >= 768px
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                // when window width is >= 1024px
                1024: {
                  slidesPerView: 4.5,
                  spaceBetween: 25,
                },
              }}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
            >
              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Government Segment"}
                  text={
                    "Use our digital screens to share public announcements, welfare schemes, and awareness campaigns with a wide audience. Support outreach with localized print ads & digital campaigns"
                  }
                  animationData={lottie_1}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Banking"}
                  text={
                    "Promote financial products like loans, savings accounts, and credit cards with impactful digital and print campaigns targeting urban and rural customers near transit points"
                  }
                  animationData={lottie_2}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"FMCG"}
                  text={
                    "Boost brand visibility and product sales through dynamic digital ads on bus stop screens and well-placed print materials in high-footfall areas across Maharashtra"
                  }
                  animationData={lottie_3}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Automobile"}
                  text={
                    "Showcase the latest models, offers, & financing options on digital screens at transit locations and complement them with engaging online & print campaigns for broader reach."
                  }
                  animationData={lottie_7}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Mobile & Cellular"}
                  text={
                    "Advertise new phone launches, network plans, and offers with strategic screen placements and digital marketing to connect with tech-savvy and rural customers alike."
                  }
                  animationData={lottie_6}
                />
              </SwiperSlide>

              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Media & Entertainment"}
                  text={
                    "Promote TV shows, movies, and events with teaser ads on our screens, print advertisements in entertainment supplements, and engaging social media campaigns"
                  }
                  animationData={lottie_9}
                />
              </SwiperSlide>

              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Cement & Steel"}
                  text={
                    "Reach contractors, builders, And home owners with tailored advertisements at bus stops in growing urban & rural markets Support campaigns with print & digital efforts highlighting key product benefits"
                  }
                  animationData={lottie_8}
                />
              </SwiperSlide>

              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Real Estate"}
                  text={
                    "Showcase your real estate projects to potential buyers through high-impact screen ads in key locations, augmented by print and digital campaigns to drive inquiries."
                  }
                  animationData={lottie_4}
                />
              </SwiperSlide>

              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Hospitality"}
                  text={
                    "Promote hotels, resorts, restaurants, and travel services through digital screens at transit hubs and engaging campaigns in both print and digital formats to attract customers."
                  }
                  animationData={lottie_5}
                />
              </SwiperSlide>

              <SwiperSlide>
                <Sector_We_Serve_card
                  title={"Education"}
                  text={
                    "Promote educational institutions, courses, and training programs through dynamic digital advertisements in strategic locations such as transit hubs, malls, and residential areas."
                  }
                  animationData={lottie_10}
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Sector_We_Serve;
